import { ref, onMounted, watchEffect, watch } from 'vue'
import { createPopper } from '@popperjs/core'
import { usePage } from '@inertiajs/inertia-vue3'

export function usePopper(options) {
  let reference = ref(null)
  let popper = ref(null)
  let instance = ref(null)

  onMounted(() => {
    watchEffect((onInvalidate) => {
      if (!popper.value) return
      if (!reference.value) return

      let popperEl = popper.value.el || popper.value
      let referenceEl = reference.value.el || reference.value

      if (!(referenceEl instanceof HTMLElement)) return
      if (!(popperEl instanceof HTMLElement)) return

      instance.value = createPopper(referenceEl, popperEl, options)

      onInvalidate(instance.value.destroy)
    })
  })

  // Update position of popper when flash message is added
  // Otherwise, poppers will be offset the height of the flash message
  watch(
    () => usePage().props.value.flash,
    () => {
      if (instance.value) instance.value.update()
    }
  )

  return [reference, popper, instance]
}

// Modifiers
export const sameWidth = {
  name: 'sameWidth',
  enabled: true,
  phase: 'beforeWrite',
  fn({ state }) {
    state.styles.popper.width = `${state.rects.reference.width}px`
  },
  requires: ['computeStyles'],
  effect: ({ state }) => {
    state.elements.popper.style.width = `${state.elements.reference.clientWidth}px`
  },
}
